import { FrendsElementStore } from ".";
import { IElementDictionary } from "../IProcessData";

export class StaticFrendsElementStore implements FrendsElementStore {
    constructor(private elements: IElementDictionary | null | undefined) {
    }

    public getElements() {
        return this.elements;
    }
}
